import React from 'react';
import { useLang } from '../../i18n';
import { Modal } from '../shared/Modal';

// Section id → icon; the title/body text comes from the locale bundle (help.sec.<id>.*).
const HELP_SECTION_IDS = [
  ['today', '📝'], ['lists', '🗂'], ['closing', '📋'], ['shopping', '🛒'], ['backup', '📦'], ['cutting', '🔪'],
  ['review', '🔎'], ['summary', '📊'], ['history', '🕓'],
];
const HELP_TIP_KEYS = ['help.tip.1', 'help.tip.2', 'help.tip.3', 'help.tip.4', 'help.tip.5'];

/** In-app "How to use" guide, opened from the header link. */
export function HelpModal({ onClose }) {
  const { t } = useLang();
  return (
    <Modal label={t('help.aria')} onClose={onClose}>
      <div className="do-print__doc">
        <h2 className="do-print__title">{t('help.title')}</h2>
        <p className="do-print__date">{t('help.intro')}</p>
        {HELP_SECTION_IDS.map(([id, icon]) => (
          <div key={id} className="do-help__sec">
            <h3 className="do-help__title">{icon} {t(`help.sec.${id}.title`)}</h3>
            <p className="do-help__body">{t(`help.sec.${id}.body`)}</p>
          </div>
        ))}
        <div className="do-help__tips">
          <h3 className="do-help__title">{t('help.goodToKnow')}</h3>
          <ul className="do-help__list">{HELP_TIP_KEYS.map(k => <li key={k}>{t(k)}</li>)}</ul>
        </div>
      </div>
      <div className="do-print__actions">
        <button className="do-modal__btn do-modal__btn--primary" onClick={onClose}>{t('help.gotIt')}</button>
      </div>
    </Modal>
  );
}
